// @flow
import * as eff from 'redux-saga/effects';
import * as Sentry from '@sentry/browser';
import {
  actionTypes,
} from 'redux-resource';

import * as actions from 'chronos-actions';
import {
  jiraApi,
} from 'chronos-api';

import {
  throwError,
} from './helpers';


export function* fetchProfile(): Generator<*, void, *> {
  try {
    yield eff.put(actions.setUiState({
      profileFetching: true,
    }));
    const [
      profile,
      permissions,
    ] = yield eff.all([
      eff.call(jiraApi.getMyself),
      eff.call(
        jiraApi.getMyPermissions,
        {
          params: {
            permissions: [
              'CREATE_ISSUES',
              'SYSTEM_ADMIN',
              'ADMINISTER_PROJECTS',
            ],
          },
        },
      ),
    ]);
    yield eff.put(actions.fillProfile({
      ...profile,
      ...permissions,
    }));
    yield eff.put({
      type: actionTypes.READ_RESOURCES_SUCCEEDED,
      resourceType: 'users',
      resources: [{
        id: profile.accountId || profile.key,
        ...profile,
      }],
    });
  } catch (err) {
    throwError(err);
  } finally {
    yield eff.put(actions.setUiState({
      profileFetching: false,
    }));
  }
}
